// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"137":"306a7aa1","194":"5116a581"}[chunkId] + ".css";
};